import { gql } from '@apollo/client/core'
import { dashboardGql } from '../../data/gql-gen/dashboard'
import { Project, Wave } from '../../data/gql-gen/dashboard/graphql'
import { SURVEY } from './Project.fragments'
import { Survey } from './Project.model'

export const CREATE_PROJECT = dashboardGql(/* GraphQL */ `
  mutation project(
    $name: String!
    $description: String!
    $accountId: ID!
    $solutionId: ID! # $hash: String!
    $creator: String!
    $projectType: ProjectType
    $surveyName: String
  ) {
    createProject(
      name: $name
      description: $description
      accountId: $accountId
      solutionId: $solutionId # hash: $hash
      creator: $creator
      projectType: $projectType
      surveyName: $surveyName
    ) {
      projectId
      projectType
      accountId
      name
      nickname
      createdDate
      sinceDate
      creator
      description
      projectMetadata {
        mrpUrl
      }
      solution {
        solutionId
        name
        createdDate
        sinceDate
      }
      surveys {
        surveyId
        createdDate
        sinceDate
        fieldworkDates {
          startDate
          endDate
        }
        name
        nickname
        state
      }
      status
    }
  }
`)

export const DELETE_PROJECT = gql`
  mutation deleteProject($projectId: ID!, $accountId: ID!) {
    deleteProject(projectId: $projectId, accountId: $accountId)
  }
`

export interface UpdateProjectData {
  updateProject: Project
}

export const UPDATE_PROJECT = gql`
  mutation updateProject($projectId: ID!, $name: String!) {
    updateProject(projectId: $projectId, name: $name) {
      projectId
    }
  }
`

export interface WaveMutationData {
  createWave?: Wave
  duplicateWave?: Wave
  renameWave?: Wave
}

// The backend assigns the number and defaults the label. It rejects a
// non-tracker project, and only one draft wave may exist at a time.
export const CREATE_WAVE = gql`
  mutation createWave($projectId: ID!) {
    createWave(projectId: $projectId) {
      waveId
      projectId
      number
      label
      status
      createdDate
      updatedDate
      surveys {
        surveyId
        name
        state
        createdDate
      }
    }
  }
`

// Copies the project's latest wave: its markets, and with them the questionnaire.
// Every wave after the first is made this way.
export const DUPLICATE_WAVE = gql`
  mutation duplicateWave($projectId: ID!) {
    duplicateWave(projectId: $projectId) {
      waveId
      projectId
      number
      label
      status
      createdDate
      updatedDate
      surveys {
        surveyId
        name
        state
        createdDate
      }
    }
  }
`

export const RENAME_WAVE = gql`
  mutation renameWave($waveId: ID!, $label: String!) {
    renameWave(waveId: $waveId, label: $label) {
      waveId
      label
      updatedDate
    }
  }
`

export interface UpdateSurveyData {
  updateSurvey: Survey
}

export const UPDATE_SURVEY = gql`
  mutation updateSurvey($surveyId: ID!, $state: SurveyState!) {
    updateSurvey(surveyId: $surveyId, state: $state) {
      ...Survey
    }
  }
  ${SURVEY}
`
